module.exports = __webpack_public_path__ + "static/media/gender_based_violence_orange.540219e1.svg";